import { Component, OnInit } from '@angular/core';
import { Users, Projects } from 'api/collections';
import { User, Company, Project } from 'api/models';
import { AlertController, ViewController, NavParams, ToastController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { App } from "ionic-angular";
import { APP_TITLE } from "../../services/config";
// import { getCompany } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import * as permissions from '../../services/permissions';
import { HttpService } from '../../services/httpService';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'add-project-user',
  templateUrl: 'add-project-user.html'
})
export class AddProjectUserComponent implements OnInit {
  searchPattern: BehaviorSubject < any > ;
  project: Project;
  company: Company;
  users: User[];
  usersSubscription: Subscription;
  constructor(
    private _app: App,
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    public httpService: HttpService,
    private sharedService: SharedService,
    public companyService: CompanyService
  ) {
    this.searchPattern = new BehaviorSubject(undefined);

    this.project = <Project>navParams.get("project");
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  ngOnInit() {
    this.observeSearchBar();
    MeteorObservable.autorun().subscribe(() => {
      this.usersSubscription = this.subscribeUsers();
    });
  }

  updateSubscription(newValue) {
    this.searchPattern.next(newValue);
  }

  observeSearchBar(): void {
    this.searchPattern.asObservable()
      .debounce(() => Observable.timer(400))
      .forEach(() => {

        this.usersSubscription = this.subscribeUsers();
      });
  }

  addProjectUser(user): void {
    let memberId = user._id
    let projectId = this.project._id;

    /*
    MeteorObservable.call('addProjectUser', memberId, projectId).subscribe({
      next: () => {
        this.showAddedUserToast(user);
        this.viewCtrl.dismiss();
      },
      error: (e: Error) => {
        this.viewCtrl.dismiss().then(() => {
          this.showError(e);
        });
      }
    });
    */

    this.httpService.MeteorCall(
      'addProjectUser',
      memberId,
      projectId
    ).then(() => {
      this.showAddedUserToast(user);
      this.viewCtrl.dismiss();
    })
    .catch((e: Error) => {
      this.viewCtrl.dismiss().then(() => {
        this.showError(e);
      });
    });
  }

  subscribeUsers(): any {
    // const subscription = MeteorObservable.subscribe('companyUsers', this.project.companyId);
    const subscription = this.httpService.MeteorSubscribe('companyUsers', this.project.companyId);
    this.httpService.privateLoopAction(true).then(()=>{
      const autorun = MeteorObservable.autorun();
      return Observable.merge(subscription, autorun).subscribe(() => {
        this.company = this.companyService.getCompany(this.project.companyId);
        this.users = this.findUsers();
      });
    });
  }

  findUsers(): User[] {
    if (!this.project) {
      return;
    }

    const { companyId } = this.project;
    const searchPattern = this.searchPattern.getValue();
    const query = {
      _id: { $nin: this.project.memberIds || [] }, // exclude members already in the project
      companyIds: companyId,
    };
    if (searchPattern) {
      query['profile.name'] = { $regex: searchPattern, $options: 'i' };
    }
    const users = Users.find(query, {
      fields: { profile: 1 },
      sort: {'profile.name': 1},
      limit: 50
    }).fetch();
    return _.orderBy(users, [(user) => {
      return this.company && permissions.isCompanyAdmin(this.company, user);
    }, 'profile.name'], ['desc', 'asc']);
  }

  isCompanyAdmin(user: User) {
    return this.company && permissions.isCompanyAdmin(this.company, user);
  }

  showError(e: Error): void {
    console.error(e);

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }

  showAddedUserToast(user: User) {
    let toast = this.toastCtrl.create({
      message: `${user.profile.name} has been added to the Project`,
      duration: 2500,
      position: 'bottom',
      dismissOnPageChange: true,
    });

    toast.present();
  }

};



// WEBPACK FOOTER //
// ./src/pages/add-project-user/add-project-user.ts